import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;
    const currentValue = this.el.nativeElement.value;

    if (currentValue.length === 0 && inputChar === '.') {
      event.preventDefault();
    }

    if (inputChar === '.' && currentValue.includes('.')) {
      event.preventDefault();
    }

    if (!/[\d.]/.test(inputChar)) {
      event.preventDefault();
    }

    if (currentValue.includes('.')) {
      const decimalPart = currentValue.split('.')[1];
      if (decimalPart && decimalPart.length >= 2) {
        event.preventDefault();
      }
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let inputValue = this.el.nativeElement.value;
    if (inputValue.length > 7) {
      this.el.nativeElement.value = inputValue.slice(0, 7);
    }

    const regex = /^\d{0,5}(\.\d{0,2})?$/;
    if (!regex.test(inputValue)) {
      this.el.nativeElement.value = inputValue.slice(0, -1);
    }
  }
}